import { jsxs as T, Fragment as X, jsx as c } from "react/jsx-runtime";
import { forwardRef as Z, useState as q, useCallback as z, useMemo as y } from "react";
import * as e from "@radix-ui/react-popover";
import t from "./index.es825.js";
import G from "classnames";
import { Z_INDEX_POPOVER as H } from "./index.es191.js";
import { InlineEditMenuContainer as J } from "./index.es826.js";
import { BasicMenuItem as L } from "./index.es83.js";
import { MenuCTAItem as P } from "./index.es827.js";
import { onKeyDownEsc as Q } from "./index.es528.js";
const M = Z(
  ({
    children: E,
    hasPointer: N,
    onPointerDownOutside: f,
    side: s,
    parentElement: b,
    CTA: l,
    scaleToAnchor: x,
    isInlineModeVisible: u,
    inlineMode: r,
    isRawContent: g,
    setOpenState: m,
    zIndex: F = H,
    isModalPopover: K = !1,
    pointerPosition: a = "center",
    ignoreFocusOutside: R = !0,
    hideWhenDetached: j = !0,
    hasCustomItem: k = !0,
    minWidth: _,
    ...$
  }, A) => {
    const [v, C] = q(!1), w = s === "top" || s === "bottom", B = G(t.content, {
      [t[`arrow--${a}`]]: w && a !== "center",
      [t[`arrow--vertical--${a}`]]: !w && a !== "center",
      [t.isModalPopover]: K,
      [t.scaleToAnchor]: x
    }), D = z(
      (o) => Q(
        o,
        () => {
          setTimeout(() => {
            C(!1);
          }, 20);
        },
        !1
      ),
      []
    ), I = y(
      () => r != null && r.footer ? {
        ...r.footer,
        submit: {
          ...r.footer.submit,
          onClick: () => {
            var o;
            (o = r.footer) == null || o.submit.onClick(), m == null || m(!1);
          }
        },
        cancel: {
          testId: "",
          ...r.footer.cancel,
          onClick: () => {
            var o, p;
            (p = (o = r.footer) == null ? void 0 : o.cancel) == null || p.onClick(), m == null || m(!1);
          }
        }
      } : void 0,
      [r == null ? void 0 : r.footer, m]
    ), h = y(
      () => /* @__PURE__ */ T(X, { children: [
        (v || u) && r ? /* @__PURE__ */ c(J, { ...r, footer: I }) : /* @__PURE__ */ c("div", { className: t.viewport, children: E }),
        N && /* @__PURE__ */ c(e.Arrow, { className: t.arrow, width: 20, height: 10 }),
        !u && !v && k && r && /* @__PURE__ */ c("div", { className: t.additionalItems, children: /* @__PURE__ */ c(
          L,
          {
            label: "Custom",
            value: "custom-inline-edit-option",
            onClick: () => C((o) => !o)
          }
        ) }),
        l && /* @__PURE__ */ c(P, { ...l })
      ] }),
      [
        l,
        E,
        k,
        N,
        r,
        I,
        v,
        u
      ]
    );
    return g ? h : /* @__PURE__ */ c(e.Portal, { container: b, children: /* @__PURE__ */ c(
      e.Content,
      {
        ...$,
        ref: A,
        side: s,
        className: B,
        onKeyDown: D,
        onPointerDownOutside: (o) => {
          f == null || f(o), C(!1);
        },
        style: { zIndex: F, minWidth: _ },
        onFocusOutside: (o) => {
          R && o.preventDefault();
        },
        hideWhenDetached: j,
        children: h
      }
    ) });
  }
);
export {
  M as PopoverContainer
};
//# sourceMappingURL=index.es82.js.map
